import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import styles from './CustomLink.css';

const cx = classnames.bind(styles);

function CustomLink(props) {
    const { className, onClick, to, target, children, withDefaultClassName, style } = props;
    const classes = cx({
        link: withDefaultClassName,
        [className]: Boolean(className)
    });
    const handleClick = e => {
        onClick?.(e);
    };

    if (target === '_blank') {
        return (
            <a
                className={classes}
                onClick={handleClick}
                href={to}
                target='_blank'
                rel='noopener noreferrer'
                style={style}
            >
                {children}
            </a>
        );
    }

    if (target === 'custom') {
        return (
            <a
                className={classes}
                onClick={handleClick}
                href={to}
                rel='noopener noreferrer'
                style={style}
            >
                {children}
            </a>
        );
    }

    return (
        <a
            className={classes}
            onClick={handleClick}
            href={to}
            style={style}
        >
            {children}
        </a>
    );
}

CustomLink.defaultProps = {
    onClick: null,
    className: '',
    target: '',
    withDefaultClassName: true,
    style: {}
};

CustomLink.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    target: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    withDefaultClassName: PropTypes.bool,
    style: PropTypes.object
};

export default CustomLink;
